/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tags_Manage_EmptyInputs */



/**
* | output |
* | --- |
* | "You haven't created any tags yet. Open a project's tag menu to add one." |
*
* @param {Project_Tags_Manage_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tags_manage_empty = /** @type {((inputs?: Project_Tags_Manage_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tags_Manage_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben noch keine Tags erstellt. Öffnen Sie das Tag-Menü eines Projekts, um eines hinzuzufügen.")
	return /** @type {LocalizedString} */ ("You haven't created any tags yet. Open a project's tag menu to add one.")
});